import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const CreateAPlatePage = () => {
  const { find, meta } = usePageContent('create-a-plate');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Create a plate');
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="page-header__content">
          <h1 className="page-header__title">{c.pageTitle || 'Create a plate'}</h1>
        </div>
      </div>
      <div className="content-holder">
        <div
          className={`rich-text ${styles.wrapper}`}
          dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }}
        />
      </div>
    </div>
  );
};

export default CreateAPlatePage;
